var _rect, _rect2, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardCustomerManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833008,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7381_152486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 17,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7829 7.09473H8.11621V23.7614H24.7829V7.09473Z",
    fill: "#7F7F7F"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7381_152486)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7381_152486",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11621 7.09481H24.7829V23.7615H8.11621V7.09481Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7381_152486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4283 17.3995L22.6091 15.2415C23.4238 14.4268 24.9904 15.4545 24.1439 16.4503L21.5031 19.5572C21.3997 19.6788 21.281 19.7866 21.1499 19.8778C20.7241 20.1498 20.2171 20.2405 19.7176 20.2405H15.7987C15.5152 20.2405 15.2319 20.2569 14.9503 20.2897L13.8232 20.4163L11.4854 18.1476C11.4854 18.1476 12.8116 15.6431 15.4131 16.363C15.8997 16.4976 16.4032 16.5619 16.9081 16.5619H19.4837C20.6962 16.5619 20.7057 18.4884 19.4736 18.4884H17.2314",
    stroke: "#7F7F7F",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2884 23.3665L14.5125 21.0846C14.5131 21.084 14.5131 21.083 14.5124 21.0824L10.7385 17.42C10.7379 17.4194 10.7368 17.4194 10.7362 17.4201L8.49121 19.7508L12.2884 23.3665Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9004 18.4748L15.9035 18.488",
    stroke: "#7F7F7F",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1619 10.6141C10.4569 10.6808 9.90527 11.2745 9.90527 11.997V13.4761C9.90527 13.7316 10.1124 13.9387 10.3679 13.9387H13.5397C13.7952 13.9387 14.0023 13.7316 14.0023 13.4761V11.997C14.0023 11.2739 13.4499 10.6799 12.7441 10.6139",
    stroke: "#7F7F7F",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5047 9.27549C13.5047 10.1327 12.8098 10.8276 11.9525 10.8276C11.0953 10.8276 10.4004 10.1327 10.4004 9.27549C10.4004 8.41826 11.0953 7.72334 11.9525 7.72334C12.8098 7.72334 13.5047 8.41826 13.5047 9.27549Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2605 10.6138C14.5555 10.6806 14.0039 11.2743 14.0039 11.9967V13.4759C14.0039 13.7314 14.211 13.9385 14.4665 13.9385H17.6384C17.8939 13.9385 18.101 13.7314 18.101 13.4759V11.9967C18.101 11.2737 17.5486 10.6797 16.8428 10.6137",
    stroke: "#7F7F7F",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6014 9.27549C17.6014 10.1327 16.9064 10.8276 16.0492 10.8276C15.192 10.8276 14.4971 10.1327 14.4971 9.27549C14.4971 8.41826 15.192 7.72334 16.0492 7.72334C16.9064 7.72334 17.6014 8.41826 17.6014 9.27549Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3533 10.6141C18.6483 10.6808 18.0967 11.2745 18.0967 11.997V13.4761C18.0967 13.7316 18.3038 13.9387 18.5593 13.9387H21.7312C21.9867 13.9387 22.1937 13.7316 22.1937 13.4761V11.997C22.1937 11.2739 21.6413 10.6799 20.9355 10.6139",
    stroke: "#7F7F7F",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6971 9.27549C21.6971 10.1327 21.0021 10.8276 20.1449 10.8276C19.2877 10.8276 18.5928 10.1327 18.5928 9.27549C18.5928 8.41826 19.2877 7.72334 20.1449 7.72334C21.0021 7.72334 21.6971 8.41826 21.6971 9.27549Z",
    stroke: "#7F7F7F",
    strokeWidth: 1.19792,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardCustomerManagement);
export default __webpack_public_path__ + "static/media/dashboardCustomerManagement.053e6eaf950f0546d91c559fd1fd040a.svg";
export { ForwardRef as ReactComponent };